import React, { useState, useEffect, useRef } from 'react';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import DashboardHeader from './Components/DashboardHeader';
import DashboardSidebar from './Components/DashboardSidebar';
import DashboardContent from './Components/DashboardContent';
import VersionCheck from './Components/VersionCheck';
// adjust path if needed


const IAMDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState('AppDashboard');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  
  const sidebarRef = useRef(null);
  const headerRef = useRef(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDesktopToggle = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleMobileToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  // Handle outside click to close sidebar
  useEffect(() => {
    const handleClickOutside = (event) => {
      console.log(event.target.id, selectedMenu);
      // Don't close if clicking on sidebar or header
      if (sidebarRef.current && sidebarRef.current.contains(event.target)) {
        return;
      }
      if (headerRef.current && headerRef.current.contains(event.target)) {
        return;
      }

      // Close sidebar on outside click
      
      if (mobileOpen && isMobile && event.target.textContent != 'Preview') {
        setMobileOpen(false);
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sidebarOpen, mobileOpen, isMobile]);

  // Handle menu selection with sidebar closing
  const handleMenuSelect = (menu) => {
    setSelectedMenu(menu);
    // Reset group and user selection when changing menus
    if (menu !== 'Group Chat') {
      setSelectedGroup(null);
    }
    if (menu !== 'Chat') {
      setSelectedUser(null);
    }
    // Close sidebar on menu selection for both mobile and desktop
    if (isMobile) {
      setMobileOpen(false);
    } else {
      //setSidebarOpen(false);
    }
  };

  // Handle group selection for chat
  const handleGroupSelect = (group) => {
    setSelectedGroup(group);
  };

  // Handle user selection for one-to-one chat
  const handleUserSelect = (user) => {
    setSelectedUser(user);
  };

  // Handle back to categories
  const handleBackToCategories = () => {
    setSelectedGroup(null);
  };

  // Handle back to user list
  const handleBackToUserList = () => {
    setSelectedUser(null);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', backgroundColor: '#F5F5F5' }}>
      <CssBaseline />

      <div ref={headerRef}>
        <DashboardHeader
          onDrawerToggle={isMobile ? handleMobileToggle : handleDesktopToggle}
          onGoToInvitation={() => handleMenuSelect('Send Invitation')}
          isGroupChatActive={selectedMenu === 'Group Chat' && selectedGroup !== null}
          isOneToOneChatActive={selectedMenu === 'Chat' && selectedUser !== null}
          onBackToCategories={handleBackToCategories}
          onBackToUserList={handleBackToUserList}
          selectedGroup={selectedGroup}
          selectedUser={selectedUser}
        />
      </div>

      <div ref={sidebarRef}>
        <DashboardSidebar
          isMobile={isMobile}
          sidebarOpen={sidebarOpen}
          mobileOpen={mobileOpen}
          handleMobileToggle={handleMobileToggle}
          onMenuSelect={handleMenuSelect}
          selectedMenu={selectedMenu}
        />
      </div>

      <DashboardContent 
        selectedMenu={selectedMenu} 
        sidebarOpen={sidebarOpen}
        selectedGroup={selectedGroup}
        selectedUser={selectedUser}
        onGroupSelect={handleGroupSelect}
        onUserSelect={handleUserSelect}
        onBackToCategories={handleBackToCategories}
        onBackToUserList={handleBackToUserList}
        onMenuSelect={handleMenuSelect}
      />
      
      {/* Version Check Component */}
      <VersionCheck />
    </Box>
  );
};

export default IAMDashboard;
